import React, { Component } from 'react';

import Botao from './Botao';
import ControleGabineteStore from '../../store/ControleGabineteStore';
import { CompareArrows } from '@mui/icons-material';

class BotaoDistribuir extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                <Botao
                    label="Movimentar"
                    redirectTo="/escaninho/filtrado"
                    pathnameConfig={['/adicionarControleGabinete', '/configuracaoGabinete']}
                    controleNumero={ControleGabineteStore.controleDistribuir?.numero}
                    startIcon={<CompareArrows />}
                />
            </div>
        );
    }
}

export default (BotaoDistribuir);